import React, { createContext, useContext, useEffect, useState } from 'react';
import { Language } from '../types';
import { en, fi, ar, es, fr, tr } from '../translations';

const translations: Record<Language, typeof en> = { 
  [Language.EN]: en,
  [Language.FI]: fi,
  [Language.AR]: ar,
  [Language.ES]: es,
  [Language.FR]: fr,
  [Language.TR]: tr
};

interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: typeof en;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [language, setLanguage] = useState<Language>(Language.EN);

  useEffect(() => {
    const saved = localStorage.getItem('app_lang');
    if (saved) setLanguage(saved as Language);
  }, []);

  const handleSetLanguage = (lang: Language) => {
    localStorage.setItem('app_lang', lang);
    setLanguage(lang);
  };

  const t = translations[language] || en;

  return (
    <LanguageContext.Provider value={{ language, setLanguage: handleSetLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used within LanguageProvider');
  return context;
};
